/** 中国大陆 11 位手机号 */
export const PHONE_PATTERN = /^1[3-9]\d{9}$/;

/** 常用邮箱格式 */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidPhone(phone: string): boolean {
  return PHONE_PATTERN.test(phone.trim());
}

export function isValidEmail(email: string): boolean {
  return EMAIL_PATTERN.test(email.trim());
}
